import { Reason, Result } from "../models/result";

class AppError extends Error {
  status?: number;
  reasons: Reason[];
  constructor(ErrorResponse: Result<any>, message?: string) {
    super(message);
    this.reasons = ErrorResponse.reasons || [];
    this.name = "AppError";
    this.status = ErrorResponse.statusCode;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AppError);
    }
  }
}

export default AppError;